import {
  forwardRef,
  MutableRefObject,
  useEffect,
  useRef,
  useState
} from "react";
import { _c } from "../../../../services/text-services";
// @ts-ignore
// @ts-ignore 
import styles from "./icibs.component.module.scss";

interface SingleCharProps {
  position: number;
  setNextDigit: (digit: number) => void;
}

const SingleChar = forwardRef((props: SingleCharProps, ref: any) => {
  const { position, setNextDigit } = props;
  const [value, setValue] = useState("");
  return (
    <input
      onKeyUp={e => {
        e.preventDefault();
        
        if (e.key === "Backspace") {
          if (value === "") {
            // console.log("Backspace on an empty room on position: ", position);
            setNextDigit(position - 1);
          } else {
            setValue("");
          }
        }
        if ("1234567890۱۲۳۴۵۶۷۸۹۰".includes(e.key)) {
          setValue(e.key);
          setNextDigit(position + 1);
        }
      }}
      onFocus={e => setValue("")}
      value={value}
      type="tel"
      ref={ref}
      maxLength={1}
      className={_c(styles, "card")}
      onChange={e => {}}
    />
  );
});


interface IcibsProps {
    setOutput: (output: string) => void;
}

function Icibs({setOutput}: IcibsProps) {
  const [nextDigit, setNextDigit] = useState(0);
  const [refArr, setRefArr] =
    useState<Array<MutableRefObject<HTMLInputElement | undefined>>>();
  const r1 = useRef<HTMLInputElement>();
  const r2 = useRef<HTMLInputElement>();
  const r3 = useRef<HTMLInputElement>();
  const r4 = useRef<HTMLInputElement>();
  const r5 = useRef<HTMLInputElement>();

  useEffect(() => {
    // console.log("current unreliable Digit: ", nextDigit);
    if (!refArr) return;
    if (!nextDigit || nextDigit < 1) return;
    // console.log("current Digit: ", nextDigit);
    let tmpToken = "";

    if (nextDigit <= 5) {
      const nextRef = refArr[nextDigit - 1].current;
      if (nextRef?.value) {
        // console.log("on a full room of: ", nextRef.value);
        nextRef.focus();
        return;
      }
    }

    for (let i = 0; i < refArr.length; i++) {
      const ref = refArr[i];
      if (ref?.current?.value === "") {
        ref.current.focus();
        return;
      }
      tmpToken += ref?.current?.value;
    }
    tmpToken.length === 5 && setOutput(tmpToken); 
  }, [nextDigit]);

  useEffect(() => {
    if (!r1 || !r2 || !r3 || !r4 || !r5) return;
    if (!refArr && r1 && r2 && r3 && r4 && r5) {
      setRefArr([r1, r2, r3, r4, r5]);
    }
  }, [r1, r2, r3, r4, r5]);


  useEffect(() => {
    refArr && refArr[0]?.current?.focus();
  }, [refArr]);

  return (
    <div className={_c(styles, "input-container")}>
      <div className={_c(styles, "input-wrap")}>
        {refArr &&
          [1, 2, 3, 4, 5].map(i => (
            <SingleChar
              key={`single-char-${i}`}
              ref={refArr[i - 1]}
              position={i}
              setNextDigit={nextDigit => setNextDigit(nextDigit)}
            />
          ))}
      </div>
    </div>
  );
}

export default Icibs;
